import { createContext as reactCreateContext } from 'react'

import type { Store, TypedNode } from '@rehaje/core'

function createContext<T = any>(displayName?: string, defaultValue?: T) {
  const context = reactCreateContext<T | undefined>(defaultValue)
  context.displayName = displayName
  return context
}

export const StoreContext = createContext<Store>('StoreContext')
export const TypedNodeContext = createContext<TypedNode>('TypedNodeContext')
